import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@mui/material';
import useThemeStyles from '../../hooks/useThemeStyles';

// Color palette for family tags
const familyColors = [
  '#FFE082', // Light yellow
  '#C5E1A5', // Light green
  '#90CAF9', // Light blue
  '#F48FB1', // Light pink
  '#CE93D8', // Light purple
  '#A5D6A7', // Light mint
  '#FFCC80', // Light orange
  '#B39DDB', // Light lavender
];

// Generate a consistent color for a family based on its name
const getFamilyColor = (familyName) => {
  if (!familyName) return familyColors[0];
  let hash = 0;
  for (let i = 0; i < familyName.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    hash = familyName.charCodeAt(i) + ((hash << 5) - hash);
  }
  return familyColors[Math.abs(hash) % familyColors.length];
};

const FamilyPill = ({ family, onClick }) => {
  const { colors } = useThemeStyles();

  const familyColor = useMemo(() => getFamilyColor(family?.familyName), [family?.familyName]);

  if (!family || !family.familyName) {
    return null;
  }

  return (
    <Chip
      label={family.familyName}
      onClick={onClick}
      size="small"
      sx={{
        backgroundColor: familyColor,
        color: colors.text.primary,
        fontSize: '0.8rem',
        height: '24px',
        fontWeight: 500,
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.2s ease',
        '&:hover': onClick
          ? {
              opacity: 0.8,
              transform: 'scale(1.05)',
            }
          : {},
      }}
    />
  );
};

FamilyPill.propTypes = {
  family: PropTypes.shape({
    id: PropTypes.string,
    familyName: PropTypes.string,
  }),
  onClick: PropTypes.func,
};

FamilyPill.defaultProps = {
  family: null,
  onClick: null,
};

export default FamilyPill;
